import { useI18n } from "./integrations/formatjs/I18nContext";
const useI18nTime = ({ domain, value, hour, minute, timeZone, }) => {
    const intl = useI18n({ domain });
    return intl.formatTime(value, { hour, minute, timeZone });
};
export { useI18nTime };
